import styled from 'styled-components';

export default styled.div`
  justify-content: center;
  flex-direction: column;
  align-content: center;

  align-items: center;
  position: absolute;
  display: flex;

  height: 100%;
  width: 100%;
  gap: 5vmax;

  left: 0;
  top: 0;
`;
